import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import { anyUploadInProgress, consentsAccepted } from "../requestSubmissionValidator";
import { STEPS, UZOP_STEPS } from "../steps/Steps";
import "./Actions.scss";
import Next from "./Next";
import Previous from "./Previous";
import Quit from "./Quit";
import Save from "./Save";
import Submit from "./Submit";
import Sign from "./Sign";
import "./Actions.scss";
import { UserContext } from "../../../../common/user/UserContext";

function Actions() {
  const { state } = useContext(RequestSubmissionContext);
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [quitDisabled, setQuitDisabled] = useState(false);
  const [saveDisabled, setSaveDisabled] = useState(false);
  const [nextDisabled, setNextDisabled] = useState(false);
  const [previousDisabled, setPreviousDisabled] = useState(false);
  const [signDisabled, setSignDisabled] = useState(false);

  const user = useContext(UserContext);

  const { t } = useTranslation();

  useEffect(() => {
    setSubmitEnabled(consentsAccepted(state.review.consents));
    setSignDisabled(consentsAccepted(state.review.consents));
  }, [state.review.consents]);

  useEffect(() => {
    let uploadInProgress = anyUploadInProgress(state.upload.documents);

    setQuitDisabled(uploadInProgress);
    setSaveDisabled(uploadInProgress);
    setNextDisabled(uploadInProgress);
    setPreviousDisabled(uploadInProgress);
    setSignDisabled(uploadInProgress);
  }, [state.upload.documents]);

  return (
    <div className="buttons is-centered mb-2">
      <Previous
        disabled={state.activeStepIndex === 0 || previousDisabled}
        label={t("requests.submission.actions.previous")}
      />
      <Quit
        disabled={quitDisabled}
        label={t("requests.submission.actions.quit")}
        id={state.id}
        uid={state.uid}
      />
      <Save
        disabled={saveDisabled}
        label={t("requests.submission.actions.save")}
        id={state.id}
        uid={state.uid}
      />
      <Next
        display={
          user.place !== "UZOP"
            ? state.activeStepIndex < STEPS.REVIEW
            : state.activeStepIndex < UZOP_STEPS.REVIEW
        }
        disabled={nextDisabled}
        label={t("requests.submission.actions.next")}
      />
      <Sign
        disabled={!signDisabled}
        label={"Potpiši"}
        display={state.activeStepIndex === STEPS.REVIEW}
        id={state.id}
        uid={state.uid}
      />
      <Submit
        display={
          user.place !== "UZOP"
            ? state.activeStepIndex === STEPS.REVIEW
            : state.activeStepIndex === UZOP_STEPS.REVIEW
        }
        disabled={!submitEnabled}
        label={t("requests.submission.actions.submit")}
        id={state.id}
        uid={state.uid}
      />
    </div>
  );
}

export default Actions;
